<template>
    <section class="main-con">
        <div class="con-tit">
            {{$t('terms.contract')}}
        </div>
        <div class="con-block con-about">
            <div class="about-main" v-html="$t('terms.contractMain')">
            </div>
            <ul class="notice-list">
                <li>
                    <p class="list-tit">第一条、同意之效力及范围</p>
                    <p class="list-des">
                        消费者了解一旦消费者完成Komoe Game平台帐号注册后，即表示消费者已经详细审阅并了解本合约的所有条款达三日以上，并愿意完全遵守本合约与本游戏服务相关之游戏管理规章、规则。
                    </p>
                    <p class="list-des">
                        游戏服务之申请，若消费者为无行为能力人（如未满七岁之未成年人），应由其法定代理人代为之；若为限制行为能力人（满七岁但未满二十岁），应得法定代理人之同意。
                    </p>
                    <p class="list-des">
                        为促进儿童及少年身心健全发展，并保障其相关权益，消费者了解本服务属于「游戏软体分级管理办法」分类标准下之应属级别，具体级别请参本服务游戏软体说明、下载、起始网页或连结处旁之标示。一旦消费者注册Komoe Game平台帐号并且登录帐号后，即推定消费者已符合相关法令对使用本级别之服务的年龄要求。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第二条、合约书适用之范围</p>
                    <p class="list-des">
                        企业经营者提供消费者本服务，消费者及企业经营者双方关于本服务之权利义务，依本合约条款之约定定之。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第三条、合约之内容</p>
                    <p class="list-des">
                        以下视为本合约之一部分，与本合约条款具有相同之效力：
                        <ul>
                            <li>
                                一、企业经营者有关本游戏服务之广告或宣传内容。
                            </li>
                            <li>
                                二、计费制游戏之费率表及游戏管理规则、规章。
                            </li>
                        </ul>
                    </p>
                    <p class="list-des">
                        前项合约内容条款或有疑义者，应为消费者有利之解释。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第四条、名词定义</p>
                    <p class="list-des">
                        本合约之名词定义如下：
                        <ul>
                            <li>
                                一、游戏服务：係指消费者透过网际网路连线经由企业经营者所架设之网路伺服器，使消费者得与其他不特定之多数人得同时连线进行游戏之软体。
                            </li>
                            <li>
                                二、游戏网站：係指由企业经营者为提供本游戏服务所建置之网站。
                            </li>
                            <li>
                                三、游戏管理规则：係指由企业经营者订立，专供为规范游戏进行方式、会员行为守则等相关规则。
                            </li>
                            <li>
                                四、游戏历程：係指自消费者登入本游戏起至登出本游戏时止，电脑系统对消费者使用游戏服务之进行过程所为之纪录。
                            </li>
                            <li>
                                五、储值：係指消费者预付企业经营者之金额或其馀额。
                            </li>
                            <li>
                                六、外挂程式：係指非由企业经营者提供，以影响或改变企业经营者游戏服务之运作、营运、进行方式为目的之程式。
                            </li>
                            <li>
                                七、虚拟物品：係指消费者经由游戏程式所取得之物品，包括但不限于消费者以储值金额所购买之虚拟货币、企业经营者免费提供、或消费者进行游戏中之活动所取得之物品或类此有利于游戏进行之物品。
                            </li>
                            <li>
                                八、游戏套件：係指具备主、副程式，且能完整执行游戏服务所有功能之软体。
                            </li>
                            <li>
                                九、下载相关软体：係指由网路下载游戏套件之行为。
                            </li>
                            <li>
                                十、必要成本：係指企业经营者为履行本合约所支出之成本或已给付予第三人之费用。
                            </li>
                        </ul>
                    </p>
                </li>
                <li>
                    <p class="list-tit">第五条、游戏点数储值</p>
                    <p class="list-des">
                        为让消费者体会本游戏之本质与乐趣，并于了解自身消费需求后再为虚拟物品之购买，消费者应于充份检视游戏内容后，始得于开始游戏七日内储值其所持有游戏帐号，包括但不限于购买任何虚拟物品、功能性道具或装饰性道具等。
                    </p>
                    <p class="list-des">
                        消费者购买企业经营者之游戏点、月卡、启动码或相关产品包一经开卡使用后，即表示已经确认使用企业经营者提供各项服务之消费，已存入游戏帐号的服务点数，消费者将无法转让给第三人。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第六条、服务范围</p>
                    <p class="list-des">
                        本合约所提供之服务，係由消费者以个人电脑、行动装置或其他方式用以下载、存取游戏应用程式并透过网际网路连线登入进行本游戏后，所有基于该游戏程式所产生之内容。但此不包括消费者向网际网路接取服务业者申请接取网际网路之服务，及提供上网所需之各项硬体设备。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第七条、游戏登录</p>
                    <p class="list-des">
                        消费者申请使用本游戏服务，应于游戏网站或依游戏需求登录与身分証明文件相符之个人资料。消费者所登录之个人资料，有错误或已变更时，应立即更正之。
                    </p>
                    <p class="list-des">
                        如消费者未提供正确之个人资料或原提供之资料已不符合真实而未更新，企业经营者得于消费者提供真实资料或更新资料前，暂停本服务（包含但不限于暂停消费者使用游戏服务及提供游戏历程查询之服务）。但消费者能以个人资料以外之方式证明其为契约当事人者，不在此限。
                    </p>
                    <p class="list-des">
                        消费者得于开始游戏后七日内，以电子邮件或书面告知企业经营者解除本合约，消费者无需说明理由及负担任何费用。解除合约后，消费者得就未使用之付费购买点数向企业经营者请求退费。
                    </p>
                    <p class="list-des">
                        若有限制行为能力人未经法定代理人同意或无行为能力人未由法定代理人代为付费购买点数致生法定代理人主张退费时，法定代理人应备妥证明文件并提出申请，经企业经营者确认后，退还消费者未使用之游戏费用。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第八条、计费标准</p>
                    <p clss="list-des">本游戏服务之收费计算方式为：</p>
                    <p class="list-des">
                        免费制，但亦提供部分收费道具供选购。
                    </p>
                    <p class="list-des">
                        费率调整时，企业经营者应于预定调整生效日三十日前于游戏网站、游戏进行中、游戏登入页面或购买页面公告；若消费者于注册帐号时已登录通讯资料者，并依消费者登录之通讯资料通知消费者。
                    </p>
                    <p class="list-des">
                        费率如有调整时，应自调整生效日起按新费率计收；若新费率高于旧费率时，消费者在新费率生效日前已于游戏网站中购买使用或登录之付费储值点数或游戏费用应依旧费率计收。
                    </p>
                    <p class="list-des">
                        消费者知悉并同意本游戏服务中之虚拟物品（货币）之消耗计算方式，为优先扣除储值所获得之虚拟物品（货币），而该虚拟物品（货币）扣除完毕方扣除免费获得之虚拟物品（货币）。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第九条、本游戏应载明之资讯</p>
                    <p class="list-des">
                        企业经营者应于游戏网站及游戏套件包装上载明以下事项：
                        <ul>
                            <li>
                                一、依游戏软体分级管理办法规定标示游戏分级级别及禁止或适合用之年龄层。
                            </li>
                            <li>
                                二、进行本游戏之最低软硬体需求。
                            </li>
                            <li>
                                三、本游戏提供通讯安全锁装置，消费者可自行设定使用号码。
                            </li>
                            <li>
                                四、有提供付费购买之机会中奖商品或活动，其活动内容、奖项及中奖等资讯，并应记载「此为机会中奖商品，消费者购买或参与活动不代表即可获得特定商品」等提示。
                            </li>
                        </ul>
                    </p>
                </li>
                <li>
                    <p class="list-tit">第十条、帐号与密码之使用</p>
                    <p class="list-des">
                        企业经营者于消费者完成注册程序后，即提供一组帐号及密码；该组帐号及密码仅供消费者使用。消费者不得将该组帐号、密码转让或出借予第三人使用，如因而产生纠纷，由消费者自行负责。
                    </p>
                    <p class="list-des">
                        前项之密码得依企业经营者提供之修改机制进行变更。企业经营者人员(含客服人员、游戏管理员)绝不会主动询问消费者之密码。消费者就其所持有之游戏帐号及密码的保管负全责，如因保管不周致帐号、密码遭他人非法使用，此属可归责于消费者之情形，亦由消费者自行负责。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第十一条、帐号与密码遭非法使用之通知与处理</p>
                    <p class="list-des">
                        当事人之一方如发现第三人非法使用消费者之帐号，或有使用安全遭异常破坏之情形时，应立即通知对方。企业经营者于查证并确认有前述情事，得暂停该组帐号或密码之使用权限，以电子邮件或其他方式通知消费者更换新密码，立即限制第三人就本游戏服务之使用权利。
                    </p>
                    <p class="list-des">
                        企业经营者应于暂时限制游戏服务使用权利之时起，即刻以官网公告、游戏通知或以电子邮件或其他方式通知前项第三人提出说明。如该第三人未于接获通知时起七日内提出说明，企业经营者应直接回复遭不当移转之电磁纪录予消费者，如不能回复时可採其他双方同意之相当补偿方式，并于回复后解除对第三人之限制；惟企业经营者有提供免费安全装置(如防盗卡、电话锁等)而消费者不使用或有其他可归责于消费者之事由者，企业经营者得不负回复或补偿责任。
                    </p>
                    <p class="list-des">
                        第一项电之第三人不同意企业经营者前项之处理时，消费者得依报桉程序，循司法途径处理。
                    </p>
                    <p class="list-des">
                        企业经营者依第一项规定限制消费者或第三人之使用权时，在限制使用期间内，企业经营者不得向消费者或第三人收取费用。
                    </p>
                    <p class="list-des">
                        消费者如有申告不实之情形致生企业经营者或第三人权利受损时，应负一切法律责任。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第十二条、游戏历程之保存与查询</p>
                    <p class="list-des">
                        企业经营者应保存消费者之个人游戏历程纪录，且保存期间为三十天，以供消费者查询。逾期者企业经营者无法受理查询申请。
                    </p>
                    <p class="list-des">
                        消费者得以书面、网路，或亲自至企业经营者之服务中心申请调阅消费者之个人游戏历程，且须提出与身份証明文件相符之个人资料以供查验，企业经营者得酌收新台币两百元作为查询费用，由消费者负担。
                    </p>
                    <p class="list-des">
                        企业经营者接获消费者之查询申请，应提供第一项所列之消费者个人游戏历程，并于七日内以储存媒介或书面或电子邮件方式提供资料。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第十三条、个人资料</p>
                    <p class="list-des">
                        关于个人资料之保护，依相关法令规定处理。
                    </p>
                    <p class="list-des">
                        除依法律规定或相关主管机关要求外，未经消费者同意时，企业经营者不得任意出售、交换、出租或公开消费者的姓名、地址、电子邮件信箱，以及其他依法受保护之个人资讯。
                    </p>
                    <p class="list-des">
                        企业经营者于履行约目的范围内，得使用消费者之个人资讯以提供消费者其他服务。
                    </p>
                    <p class="list-des">
                        消费者同意企业经营者得就消费者之个人资料作成会员统计资料。如该统计资料不涉及揭露消费者之个人身份，消费者同意并允许企业经营者为任何合法公开之使用。
                    </p>
                    <p class="list-des">
                        于下列情形发生时，企业经营者得依法公开消费者之个人资讯或游戏历程：
                        <ul>
                            <li>一、因应法令及相关主管机关之要求。</li>
                            <li>二、为保障企业经营者之财产及权益。</li>
                            <li>三、在紧急情况下为保障企业经营者会员或公众人身安全时。</li>
                            <li>四、与第三人相关之游戏历程，经该第三人向企业经营者调阅者。</li>
                        </ul>
                    </p>
                </li>
                <li>
                    <p class="list-tit">第十四条、电磁记录</p>
                    <p class="list-des">
                        本游戏服务之所有电磁纪录均属企业经营者所有，企业经营者并应维持消费者相关电磁纪录之完整。
                    </p>
                    <p class="list-des">
                        消费者对于前项电磁记录有使用支配之权利，但不包括本游戏服务范围外之移转、收益行为。
                    </p>
                    <p class="list-des">
                        为保障消费者权益请勿透过非企业经营者授权之任何形式之购买管道（包括但不仅限于交易平台、游戏物品交易商），购买虚拟货币、道具、虚拟物品、点月卡或赠品等物品，企业经营者对其衍生之问题、纠纷概不做任何处理及售后服务。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第十五条、资讯公开</p>
                    <p class="list-des">
                        企业经营者应于游戏网站上提供本游戏相关资讯，并定期更新。
                    </p>
                    <p class="list-des">
                        企业经营者就本服务之计分方式、非付费购买之物品掉落或虚拟物品（货币）获得之机率为企业经营者内部资讯，消费者无权利请求游戏公司提供或公开。
                    </p>
                    <p class="list-des">
                        进行游戏服务时所有数据资料，包括但不限于角色、装备、物品、怪物能力或类此之资讯，均由企业经营者设计，如为游戏公平进行，企业经营者得以适度调整该等参数，并进行公告。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第十六条、连线品质</p>
                    <p class="list-des">
                        企业经营者为维护本游戏服务各项系统设备而预先计画暂停本游戏服务之一部或全部时，应于七日前于游戏网站或游戏页面中公告，但因临时性、急迫性或不可归责于企业经营者之事由者，不在此限。
                    </p>
                    <p class="list-des">
                        因可归责企业经营者之事由，致消费者不能连线使用本游戏服务时，企业经营者应立即更正或修复。于消费者无法使用本游戏服务期间遭扣除之游戏费用或游戏内商品，企业经营者应返还消费者已扣除之游戏费用或商品，无法返还时则提供其他合理之补偿。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第十七条、企业经营者及消费者责任</p>
                    <p class="list-des">
                        企业经营者应依本合约之规定负有于提供本服务时，维护其自身电脑系统，符合当时科技或专业水准可合理期待之安全性。
                    </p>
                    <p class="list-des">
                        电脑系统或电磁记录受到破坏，或电脑系统运作异常时，企业经营者应于採取合理之措施后儘速予以回复。
                    </p>
                    <p class="list-des">
                        企业经营者违反前二项规定或因游戏程式漏洞，致生消费者游戏内资料受有损害时，应依消费者之受损害情形，负损害赔偿责任，但企业经营者能证明其无过失者，得减轻其赔偿责任。
                    </p>
                    <p class="list-des">
                        企业经营者电脑系统发生第二项所称情况时，于完成修复并正常运作之前，企业经营者不得向消费者收取费用。
                    </p>
                    <p class="list-des">
                        消费者因共用帐号、委託他人付费购买点数衍生与第三人间之纠纷，企业经营者得不予协助处理。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第十八条、游戏管理规则</p>
                    <p class="list-des">
                        为规范游戏进行之方式，企业经营者应订立合理公平之游戏管理规则，消费者应遵守企业经营者公告之游戏管理规则。
                    </p>
                    <p class="list-des">
                        游戏管理规则之变更应依第二十一条之程序为之。
                    </p>
                    <p class="list-des">
                        游戏管理规则有下列情形之一者，其规定无效：
                        <ul>
                            <li>一、抵触本合约之规定。</li>
                            <li>二、剥夺或限制消费者之合约上权利。但企业经营者依第十九条之规定处理者，不在此限。</li>
                        </ul>
                    </p>
                </li>
                <li>
                    <p class="list-tit">第十九条、违反游戏管理规则之处理</p>
                    <p class="list-des">
                        除本合约另有规定外，有事实足证消费者于本游戏中违反游戏管理规则时，企业经营者应于游戏网站公告或游戏登入页面并依消费者登录之通讯资料通知消费者。
                    </p>
                    <p class="list-des">
                        消费者第一次违反游戏管理规则，经企业经营者通知改善而未改善，企业经营者得依游戏管理规则，按其情节轻重限制消费者之游戏使用权利。如消费者因同一事由再次违反游戏管理规则时，企业经营者得立即依游戏管理规则限制消费者进行游戏之权利。
                    </p>
                    <p class="list-des">
                        企业经营者依游戏管理规则停止消费者进行游戏之权利，每次不得超过七日。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第二十条、申诉权利</p>
                    <p class="list-des">
                        消费者不满意企业经营者提供之连线品质、游戏管理、费用计费、其他相关之服务品质，或对企业经营者依游戏管理规则之处置不服时，得于收到通知之翌日起七日内至企业经营者之服务中心或以电子邮件或书面提出申诉，企业经营者应于接获申诉后，于十五日内回覆处理结果。
                    </p>
                    <p class="list-des">
                        企业经营者应于游戏网站或游戏管理规则中明订客服申诉信箱等相关联络资讯及24小时申诉管道。
                    </p>
                    <p class="list-des">
                        消费者反映第三人利用外挂程式或其他影响游戏公平性之申诉，依第一项规定办理。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第二十一条、合约之变更</p>
                    <p class="list-des">
                        企业经营者修改本合约时，应于游戏网站首页及游戏之登入页面公告之，并以消费者留存之通讯方式通知消费者。
                    </p>
                    <p class="list-des">
                        企业经营者未依前项进行公告及通知者，其合约之变更无效。
                    </p>
                    <p class="list-des">
                        消费者于第一项通知到达后十五日内：
                        <ul>
                            <li>一、消费者未为反对之表示者，企业经营者依合约变更后之内容继续提供本游戏服务。</li>
                            <li>二、消费者为反对之表示者，依消费者终止本合约之方式处理。</li>
                        </ul>
                    </p>
                </li>
                <li>
                    <p class="list-tit">第二十二条、合约之终止及退费</p>
                    <p class="list-des">
                        消费者得随时以书面通知企业经营者终止本合约。
                    </p>
                    <p class="list-des">
                        若消费者于一年内未登入使用本游戏服务，企业经营者得通知消费者于十五日内登入，如消费者届期仍未登入使用，则企业经营者得终止本合约。
                    </p>
                    <p class="list-des">
                        消费者有下列重大情事之一者，企业经营者得以消费者留存之通讯方式通知消费者后，立即终止本合约：
                        <ul>
                            <li>一、利用任何系统或工具对企业经营者电脑系统之恶意攻击或破坏。</li>
                            <li>二、以利用外挂程式、病毒程式、游戏程式漏洞或其他违反游戏常态设定或公平合理进行游戏。</li>
                            <li>三、以冒名、诈骗或其他虚伪不正等方式付费购买点数或游戏内商品。</li>
                            <li>四、无正当理由退费：指购买且取得游戏内点数或虚拟物品于使用后进行退费。</li>
                            <li>五、消费者迳为转让、约定出售或交易任何帐号或电磁纪录。</li>
                            <li>六、因同一事由违反游戏管理规则达三次以上，经依第十九条第二项通知改善而未改善者。</li>
                            <li>七、经司法机关查获从事任何不法之行为。企业经营者对前项事实认定产生错误或无法举证时，企业经营者应对消费者因终止合约所生之损害负赔偿责任。</li>
                        </ul>
                    </p>
                    <p class="list-des">
                        合约终止时，企业经营者于扣除必要成本后，应于三十日内将消费者未使用之游戏点数或费用以现金、信用卡、汇票或挂号寄发支票方式退还消费者未使用之付费购买之点数或游戏费用，或依双方同意之方式处理前述点数或费用。消费者知悉已购买且使用消耗之虚拟物品（货币），无权向游戏公司请求退费。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第二十三条、停止营运</p>
                    <p class="list-des">
                        因企业经营者停止本游戏服务之营运而终止契约者，应于终止前三十日公告于官网首页、游戏登入页面或购买页面；若消费者于注册帐号时已登录通讯资料者，则依消费者留存之通讯资料通知消费者。
                    </p>
                    <p class="list-des">
                        企业经营者未依前项期间公告并通知者，除应退还消费者未使用之付费购买点数或游戏费用且不得扣除必要成本外，并应提供消费者其他合理之补偿。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第二十四条、送达</p>
                    <p class="list-des">
                        有关本合约所有事项之通知，消费者同意企业经营者得以消费者留存之通讯资料为送达。
                    </p>
                    <p class="list-des">
                        消费者应确保留存于企业经营者之地址或电子邮件之正确，前项通讯资料若有变更，消费者应立即通知企业经营者。如怠于为变更之通知或因其他事由致通知无法到达或拒收时，以企业经营者通知发出时，推定已合法送达。
                    </p>
                    <p class="list-des">
                        因消费者之故意或过失致企业经营者无法为送达者，企业经营者对消费者因无法送达所致之损害不负任何赔偿责任。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第二十五条、智慧财产权</p>
                    <p class="list-des">
                        本游戏软体、说明书及一切相关周边产品均为着作权法所保护，图文非经企业经营者许可不得以任何方式作局部或全部之拷贝、转载或修改。消费者不得未经企业经营者事先书面同意而利用本游戏制作任何周边产品。
                    </p>
                    <p class="list-des">
                        消费者不得採用任何方法对其提供经营(或主机)服务、中间媒介服务，或对其进行拦截、模拟或重定向。这些被禁止的方法包括但不仅限于架设私人伺服器、逆向工程、修改本游戏，或添加新的组件，或使用某种工具程式来提供本游戏经营(或主机)服务。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第二十六条、准据法</p>
                    <p class="list-des">
                        本合约以中华民国法律为准据法。
                    </p>
                </li>
                <li>
                    <p class="list-tit">第二十七条、管辖法院</p>
                    <p class="list-des">
                        因本合约涉及的一切争讼，双方合意以台湾士林地方法院为第一审管辖法院，但不得排除消费者保护法第四十七条或民事诉讼法第二十八条第二项、四百三十六条之九规定小额诉讼管辖法院之适用。
                    </p>
                </li>
            </ul>
        </div>
        <div class="dash-slice"></div>
        <div class="con-tit">
            {{$t('terms.privacy')}}
        </div>
        <div class="con-block con-about">
            <ul class="notice-list">
                <li>
                    <p class="list-tit">小萌科技有限公司(以下简称「小萌科技」或「我们」)非常重视您的隐私权，在此载明我们如何搜集、处理及利用您的个人资料。当您完成注册、使用本公司会员服务时，即视为您已阅读、了解并同意接受Komoe Game隐私权政策（「本政策」）。如您不同意本政策的全部或任何一部份，请您立即停止使用本服务。如您为未成年人，确认您的法定代理人已全部了解并同意本政策之内容后，再继续使用本服务。于您使用本服务时，就本合约约定之内容，即视为已取得法定代理人之允许或同意。</p>
                    <p class="list-des">
                    </p>
                </li>
                <li>
                    <p class="list-tit">请您详细阅读以下有关隐私权保护政策的更多内容。</p>
                    <p class="list-des">
                    </p>
                </li>
                <li>
                    <p class="list-tit">小萌科技所搜集的资讯及如何处理利用</p>
                    <p class="list-des">
                        在您注册及/或进行小萌科技旗下手机游戏后，小萌科技将会搜集您于进行游戏各项行为，包括但不限于您注册帐号时提供的个人资料（如电子邮件、性别、电话）、帐号名称、游戏操作行为、每次登入游戏或消费时的装置资料（包括装置唯一识别码和广告识别码、系统语言、型号、系统版本号、是否root或越狱、解析度）、消费行为（包括消费时间与品项、支付数据如订单编号、支付时网路IP位址）、Google/Apple/Facebook授权资讯、登入状态，及其他为提供您会员服务及/或游戏游玩服务所必须搜集的各种相关资料，利用于提供会员服务及/或游玩游戏之目的，包括提供您游戏相关讯息、小萌相关产品或服务的行销资讯等。此外，为提供您更好的服务，可能针对全体使用者的人数、偏好和行为进行内部研究；此研究是根据全体使用者行为总和进行分析，并不会对个别使用者进行分析。
                    </p>
                    <p class="list-des">
                        若您浏览小萌科技网页或某些合作伙伴（以下称「第三方」）的网页以及参加某些宣传活动或赠奖游戏时，小萌科技会搜集您所输入的个人资料，包含但不限于您注册会员服务所提供之资料。这些资料可能将会使用在寄送活动赠品或是通知中奖使用，或您在使用小萌科技相关会员服务时，小萌科技会询问包括您的姓名、地址、出生日期、身分证号、联络电话等资料，以方便小萌科技辨别您的身分，为您提供更为精准及有效的服务内容。您应了解并注意，第三方可能于此类活动中与小萌科技共同或独立搜集您的个人资料，于此种情形，您与第三方间的法律关係，将不属于本政策的规范范围，您应自行确认第三方的隐私权政策内容，小萌科技亦无法保证第三方关于隐私保护的完整性及合法性。
                    </p>
                </li>
                <li>
                    <p class="list-tit">除依本政策、您的明确同意，以及下列情形外，小萌科技不会将资料提供给第三人、或超出本政策之特定目的必要范围使用：</p>
                    <p class="list-des">
                        1.受司法、警察或其他有权机关基于之要求时。
                    </p>
                    <p class="list-des">
                        2.于维护公益或保护小萌科技或他人权益时。
                    </p>
                    <p class="list-des">
                        3.因会员之行为违反法令或您与小萌科技间的契约规定时
                    </p>
                    <p class="list-des">
                        4.在紧急情况下为维护其他会员或第三人之人身、交易内容、游戏历程、个人资料之完整安全时。
                    </p>
                    <p class="list-des">
                        5.或其他为提供您游戏服务之必要而提供予小萌科技之合作伙伴。但此合作伙伴不得就所取得之资料做超出合约范围外之用途。
                    </p>
                    <p class="list-des">
                        6.其他合法途径。
                    </p>
                </li>
                <li>
                    <p class="list-tit">资料安全</p>
                    <p class="list-des">
                        小萌科技尽力以符合当时科技的合理之技术及程序，保障所有个人资料之安全。
                    </p>
                </li>
                <li>
                    <p class="list-tit">其他相关注意事项</p>
                    <p class="list-des">
                        请妥善保管您的密码及或任何个人资料，不要将任何个人资料，尤其是密码提供给任何人。在您欲离开电脑前或不再使用小萌科技的服务时，务必记得登出帐号，若您是与他人共享电脑或使用公共电脑，切记要关闭浏览器视窗，以防止他人读取您的个人资料或信件。
                    </p>
                    <p class="list-des">
                        您自愿在线上透露的各种个人资料，如在讨论区、聊天室等处公佈您的个人资料如电子邮件以及生日等，该资料均可能会被他人搜集和使用。如果您于线上公佈可被他人读取的个人资料时，您可能会收到其它团体主动提供的邮件。基本上，您的密码或任何会员帐户资料的保密性必须由您单独负责，请小心并保管您的会员资料。
                    </p>
                    <p class="list-des">
                        本政策相关名词，如未特别约定时，依Komoe Game使用者合约书（「本合约」）之约定。
                    </p>
                </li>
                <li>
                    <p class="list-tit">隐私权保护政策修订</p>
                    <p class="list-des">
                        小萌科技保有依实际况状修改修订本政策之权利，当我们有任何重大变更时将会于我们的网站上公佈，或以小萌科技认为适当的方法对您通知，烦请定期查阅，如您不能接受变更后内容的全部或一部，请您立即停止使用本服务，并通知我们终止本合约。
                    </p>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.main-con .con-tit {
    padding-top: 9.2%;
    font-size: 0.16rem;
    font-weight: bold;
    color: #2DA2D4;
    line-height: 31px;
}

.main-con .con-block {
    padding-top: 5.9%;
    color: #444;
}

.main-con .con-about {
    font-size: 0.12rem;
    line-height: 0.24rem;
}

.about-main {
    margin-bottom: 42px;
    color: #999;
}

.notice-list {
    padding: 0;
    padding-bottom: 40px;
    margin: 0;
}

.notice-list ul {
    padding: 0;
    margin: 0;
}

.notice-list li {
    list-style-type: none;
}

.notice-list > li {
    margin-bottom: 21px;
}

.notice-list .list-tit {
    font-weight: bold;
    color: #333;
}

.notice-list .list-des {
    color: #2A2A2A;
}

.dash-slice {
    height: 3px;
    background: url("../../../img/dividing_dotted.png");
}
</style>